import moment from 'moment';
import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { exportReportHostTaskText } from 'Const/report-host-tasks/domain';
import getExportReportHostTasks from 'Api/report-host-tasks/getExportReportHostTasks';

import getExportReportHostTaskRequest from './model/request/getExportReportHostTaskRequest';

const useGetExportReportHostTask = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });

      const params = getExportReportHostTaskRequest(filter);

      const response = await getExportReportHostTasks(params);

      return { response, filter };
    },
    onSuccess: ({ response, filter }) => {
      const filename = `Report Host Task ${moment(filter?.startedAt).format('DD/MM/YYYY')} - ${moment(filter?.endedAt).format('DD/MM/YYYY')}.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportHostTaskText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportHostTaskText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportReportHostTask;
